import { Injectable, ComponentFactoryResolver} from "@angular/core";
import * as _ from "lodash";

import { DynamicComponent } from "./systemComponentDynamicComponent";

/** Komponenten dynamisch laden */
@Injectable()
export class DynamicLoader {

    constructor(private _componentFactoryResolver: ComponentFactoryResolver) {
    }

    /** Eine Komponente anhand dynamischer Komponententinformationen laden
     * @param clearContainer Container vorab leeren
     * @param dynamicComponent Dynamische Komponenteninformationen
     */
    public load(clearContainer:boolean,...dynamicComponents: DynamicComponent[]) {

        for (const dynamicComponent of dynamicComponents) {
            const componentFactory = this._componentFactoryResolver.resolveComponentFactory(dynamicComponent.component);
            if (clearContainer) {
                dynamicComponent.container.clear();
            }
            dynamicComponent.reference = dynamicComponent.container.createComponent(componentFactory);
        }
    }
}
